import { render, staticRenderFns } from "./PrintIcon.vue?vue&type=template&id=4cfd4c76"
import script from "./PrintIcon.vue?vue&type=script&lang=ts"
export * from "./PrintIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports